import { CEProcessAttributesBase } from './ce-process-attributes-base'


export class CEProcessAttributes extends CEProcessAttributesBase {

}